module.exports = __webpack_public_path__ + "static/img/16_周邊店家.7593994.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/button/16_周邊店家.png
// module id = R+Q1
// module chunks = 1